export default function Testimonials() {
  const quotes = [
    {
      name: "Robin Belither",
      role: "CFO",
      text: "They left us feeling confident we knew the facts and had a plan that aligned with our goals."
    },
    {
      name: "Thomas Heath",
      role: "HR Director",
      text: "Brilliant service—supremely clear and impactful. The entire team exceeded expectations."
    },
    {
      name: "Hugo Jacobs",
      role: "CEO",
      text: "They found gaps others missed, saving me a fortune. Highly recommend their team."
    }
  ];

  return (
    <section id="testimonials" className="px-6 py-20">
      <p className="mb-4 text-center text-sm font-semibold uppercase tracking-[0.22em] text-cyan-300">
        Testimonials
      </p>
      <h2 className="mb-12 text-center text-3xl font-bold leading-tight text-white md:text-5xl">
        Clear guidance for important decisions.
      </h2>
      <div className="mx-auto grid max-w-6xl gap-6 md:grid-cols-3">
        {quotes.map((quote) => (
          <blockquote key={quote.name} className="rounded-3xl border border-white/10 bg-white/10 p-7 shadow-xl shadow-black/10 backdrop-blur">
            <p className="leading-relaxed text-slate-100">“{quote.text}”</p>
            <p className="mt-6 font-semibold text-white">
              — {quote.name}
              <span className="block text-sm font-normal text-slate-400">{quote.role}</span>
            </p>
          </blockquote>
        ))}
      </div>
    </section>
  );
}
